export default "__VITE_ASSET__67Ce2opY__"